var map = {
	"./emag1.jpg": 6584,
	"./emag2.jpg": 9397,
	"./emag3.jpg": 2118,
	"./emag4.jpg": 8076,
	"./emag5.jpg": 6527,
	"./emag6.jpg": 8613,
	"./emag7.jpg": 3479,
	"./emag8.jpg": 7915,
	"./mailbox.jpg": 7049,
	"./microphone.jpg": 6408,
	"./newsletterPressOffice.jpg": 7990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3958;